import React from "react";
// @material-ui/core components
import ViewMultaCondutor from "components/View/ViewMultaCondutor";
import LoadingFull from "components/Loading/LoadingFull";
import api from 'services/api.js';
import {serverApi} from 'services/constante.js';
import {msg} from 'services/msg.js';
import MySnackbarErro from 'components/Uteis/MySnackbarErro.js';
import checaLiberacaoMenu from 'services/checaLiberacaoMenu';

  export default class HabilitacaoMultaView extends React.Component {
  
    constructor(props) {
      super(props);
  
      checaLiberacaoMenu(props);

      this.state  = {
        multa: {Habilitacao:{}},
        loadingGrid: true,
        isErro: false
      };
      
      
    } 
    componentDidMount(){
  
      let guid = this.props.match.params.guid;
      this.setState({isErro: false});

      api.get(serverApi.url + serverApi.versao + '/Multa/Habilitacao/Resumo/Guid/' + guid).then(response => {
        this.setState({multa: response.data});
      })
      .catch(error => {
        console.error(error);
        this.setState({isErro: true}); 
       
      })
      .finally(() => {   
        this.setState({
          loadingGrid: false
        });   
      });
      
    }
    
    render() {
    return (
      <>
          <LoadingFull display={this.state.loadingGrid} />
          
            <ViewMultaCondutor multa={this.state.multa} />
          <MySnackbarErro IsErro={this.state.isErro} Mensagem={msg.semConexao} />
      </>
    );
  }
}
